import React, { useCallback, useMemo, useState } from "react";
import { useUpdateEffect } from "react-use";
import debounce from "lodash/debounce";
import PropTypes from "prop-types";
import { useACLocalStorage } from "~/components/Hooks/useACLocalStorage";
import { getUrlWithoutParams } from "~/utils/url_helper";
import { HistoryContextProvider } from "./context";

export const HistoryProvider = ({ children, timeout }) => {
  const [historyStack, setHistoryStack] = useACLocalStorage("history-stack");
  const [state, setState] = useState(() => historyStack || []);

  const updateStorage = useMemo(() => {
    return debounce(() => setHistoryStack(state), timeout);
  }, [setHistoryStack, state, timeout]);

  useUpdateEffect(() => {
    updateStorage();
  }, [updateStorage]);

  const pushToState = useCallback((item) => {
    setState((prevState) => {
      let temp = [...prevState];

      const regex = new RegExp(`^${item.overrideLastIfContains}`);

      if (
        (item.overrideLastIfContains && regex.test(temp[temp.length - 1]?.pathname)) ||
        (prevState.length > 0 &&
          getUrlWithoutParams(prevState[prevState.length - 1]?.pathname) === getUrlWithoutParams(item.pathname))
      ) {
        temp[temp.length - 1] = { pathname: item.pathname, title: item.title };

        return temp;
      }

      if (temp.length === 10) {
        temp.shift();
      }

      return [...temp, item];
    });
  }, []);

  const popFromState = useCallback(() => {
    setState((prevState) => {
      let temp = [...prevState];
      temp.pop();

      return temp;
    });
  }, []);

  return <HistoryContextProvider value={{ state, pushToState, popFromState }}>{children}</HistoryContextProvider>;
};

HistoryProvider.propTypes = {
  children: PropTypes.node,
  timeout: PropTypes.number,
};

HistoryProvider.defaultProps = {
  timeout: 300,
};
